import angular from "angular";

angular
    .module('ui-common')
    .factory('SentinelUtilsService', SentinelUtilsService);

function SentinelUtilsService() {
    return {
        hasLoggerCapability: hasLoggerCapability
    };

    function hasLoggerCapability(sentinel) {
        if (!sentinel) {
            return false;
        }
        if (sentinel.sentinelType === '100L') {
            return true;
        }
        if (sentinel.oaiDeviceProfileFlags) {
            const flags = parseInt(sentinel.oaiDeviceProfileFlags, 16);
            const BLE_BIT     = 1 << 0;  // 0x001
            const LORA_BIT    = 1 << 8;  // 0x100
            const LORAWAN_BIT = 1 << 9;  // 0x200
            const loggerMask  = BLE_BIT | LORA_BIT | LORAWAN_BIT;
            return (flags & loggerMask) !== 0;
        }
        return false;
    }
}
